module.exports = __webpack_public_path__ + "9ad506c156dd1d8ba0a830fb78a57fbd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-17.png
// module id = 1665
// module chunks = 0